import { render, staticRenderFns } from "./LiveTuoyu.vue?vue&type=template&id=f329acb6&scoped=true&"
import script from "./LiveTuoyu.vue?vue&type=script&lang=js&"
export * from "./LiveTuoyu.vue?vue&type=script&lang=js&"
import style0 from "./LiveTuoyu.vue?vue&type=style&index=0&id=f329acb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f329acb6",
  null
  
)

export default component.exports